import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/value-added-tax";

export const pagingServiceVat = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getServiceVatById = (serviceVatId) => axios.get(API_PATH + "/get-by-id/" + serviceVatId);

export const saveOrUpdateServiceVat = serviceVat => axios.post(API_PATH + "/save-or-update", serviceVat);

export const deleteServiceVat = serviceVatId => axios.delete(API_PATH + '/mark-delete/' + serviceVatId);

